// Generates the UV and size data arrays for the particles.
export default function generateParticlesData(count) {
    const gridSize = Math.ceil(Math.sqrt(count))
    const uvArray = new Float32Array(count * 2)
    const sizesArray = new Float32Array(count)
    for (let y = 0; y < gridSize; y++) {
        for (let x = 0; x < gridSize; x++) {
            const i = y * gridSize + x
            if (i >= count) break
            const i2 = i * 2
            uvArray[i2 + 0] = (x + 0.5) / gridSize
            uvArray[i2 + 1] = (y + 0.5) / gridSize
            sizesArray[i] = Math.random()
        }
    }
    return { uvArray, sizesArray }
}
